import api from 'api';
import { createSlice } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import { INotificationItem } from 'components/notifications';
import { INotificationAppointmentDetails } from 'interfaces/notification-interface';
export interface INotificationType {
  date: string;
  notifications: {
    title: string;
    description: string;
    to: string;
    type: string;
    is_read: boolean;
    created_at: string;
    updated_at: string;
    name?: string;
    data: {
      appointment_id: string;
      vehicle_id: string;
    };
  }[];
}

interface INotificationState {
  notifications: INotificationType[] | null;
  selectedNotification: INotificationItem | null;
  selectedNotificationAppointmentDetails: INotificationAppointmentDetails | null;
}

const initialState: INotificationState = {
  notifications: null,
  selectedNotification: null,
  selectedNotificationAppointmentDetails: null,
};
const notificationSlice = createSlice({
  name: 'Notifications',
  initialState: initialState,
  reducers: {
    setNotifications: (state, { payload }: { payload: INotificationType[] }) => {
      state.notifications = payload;
    },
    setSelectedNotification: (state, { payload }: { payload: INotificationItem | null }) => {
      state.selectedNotification = payload;
    },
    setSelectedNotificationAppointmentDetails: (state, { payload }: { payload: null }) => {
      state.selectedNotificationAppointmentDetails = payload;
    },
  },
});

export const getNotifications =
  (payload: { params: { type: string } }) => async (dispatch: Dispatch) => {
    try {
      const { params } = payload;
      const { data: responseData } = await api.get('/admin/notifications', {
        params: { ...params },
      });
      dispatch(setNotifications(responseData?.data));
      return Promise.resolve(responseData?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const getAppointmentDetails =
  (payload: { appointment_id: string }) => async (dispatch: Dispatch) => {
    try {
      const { appointment_id } = payload;
      const { data: responseData } = await api.get(`/admin/workshop/${appointment_id}`);
      dispatch(setSelectedNotificationAppointmentDetails(responseData?.data[0]));
      return Promise.resolve(responseData?.data[0]);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const removeNotification =
  (payload: { notification_id: string }) => async (dispatch: Dispatch) => {
    try {
      const { notification_id } = payload;
      const { data: responseData } = await api.delete(
        `/admin/remove/notification/${notification_id}`,
      );
      return Promise.resolve(responseData?.data[0]);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const readNotification =
  (payload: { notification_id: string }) => async (dispatch: Dispatch) => {
    try {
      const { notification_id } = payload;
      const { data: responseData } = await api.get(`/admin/read/notification/${notification_id}`);
      return Promise.resolve(responseData?.data[0]);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const {
  setNotifications,
  setSelectedNotification,
  setSelectedNotificationAppointmentDetails,
} = notificationSlice.actions;
export default notificationSlice.reducer;
